import styled from 'styled-components/macro';
import { PaymentOptions } from '@yme/molecules/payment-options';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const PaymentOptionsStyled = styled(PaymentOptions) `
  margin-top: ${INDENT.sm};

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: ${INDENT.l};
  }
`;
export const CardPanelWrapperStyled = styled.div `
  position: relative;
`;
